import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ApprovalTable.vue"),
          meta: { title: "Схемы заявок", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ApprovalForm.vue"),
          meta: { title: "Обновить cхему", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
